import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobSiteDriverRequestActions'
import * as api from '../../api/job/jobSiteDriverRequests'

function* jobSiteDriverRequestsRefresh(action) {
  try {
    const payload = yield call(api.getJobSiteDriverRequests, action.jobId)
    yield put({ type: constants.DRIVER_REQUESTS_REFRESH.SUCCESS, payload })
    action.next && action.next(payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DRIVER_REQUESTS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobSiteDriverRequests() {
  yield takeLatest(constants.DRIVER_REQUESTS_REFRESH.ACTION, jobSiteDriverRequestsRefresh)
}

function* sagaCreateJobSiteDriverRequest(action) {
  try {
    const payload = {
      job_id: action.jobId,
      description: action.content.description,
      requested_date: action.content.requested_date,
      needed_by_date: action.content.needed_by_date,
      requested_by: action.content.requested_by,
      point_of_contact: action.content.point_of_contact,
      special_conditions: action.content.special_conditions,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      driver_request_template_id: action.content.driver_request_template_id
    }
    yield call(api.createJobSiteDriverRequest, payload)
    yield put({ type: constants.CREATE_DRIVER_REQUEST.SUCCESS, payload })
    yield call(jobSiteDriverRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_DRIVER_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateJobSiteDriverRequest() {
  yield takeLatest(constants.CREATE_DRIVER_REQUEST.ACTION, sagaCreateJobSiteDriverRequest)
}

function* sagaUpdateJobSiteDriverRequest(action) {
  try {
    const payload = {
      driver_request_id: action.driverRequestId,
      data: {
        completed: action.content.completed,
        description: action.content.description,
        requested_date: action.content.requested_date,
        needed_by_date: action.content.needed_by_date,
        requested_by: action.content.requested_by,
        point_of_contact: action.content.point_of_contact,
        special_conditions: action.content.special_conditions,
        completed_date: action.content.completed_date,
        updated_by_id: action.userId,
        driver_request_template_id: action.content.driver_request_template_id
      }
    }
    yield call(api.updateJobSiteDriverRequest, payload)
    yield put({ type: constants.UPDATE_DRIVER_REQUEST.SUCCESS, payload })
    yield call(jobSiteDriverRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_DRIVER_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobSiteDriverRequest() {
  yield takeLatest(constants.UPDATE_DRIVER_REQUEST.ACTION, sagaUpdateJobSiteDriverRequest)
}

function* sagaDeleteJobSiteDriverRequest(action) {
  try {
    const payload = {
      driver_request_id: action.driverRequestId
    }
    yield call(api.deleteJobSiteDriverRequest, payload)
    yield put({ type: constants.DELETE_DRIVER_REQUEST.SUCCESS, payload })
    yield call(jobSiteDriverRequestsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_DRIVER_REQUEST.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobSiteDriverRequest() {
  yield takeLatest(constants.DELETE_DRIVER_REQUEST.ACTION, sagaDeleteJobSiteDriverRequest)
}

function* sagaDriverRequestReport(action) {
  try {
    yield call(api.driverRequestReport, action.driverRequestId)

    // yield put({ type: constants.DRIVER_REQUESTS_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    console.log('error', e)
    yield put({
      type: constants.DRIVER_REQUESTS_REPORT.FAILED,
      message: e.message || e
    })
  }
}

function* watchSagaDriverRequestReport() {
  yield takeLatest(constants.DRIVER_REQUESTS_REPORT.ACTION, sagaDriverRequestReport)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      driverRequestId: action.driverRequestId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { driverRequestId: action.driverRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_DRIVER_REQUEST_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const payload = yield call(api.getAttachments, action.driverRequestId)
    yield put({ type: constants.GET_DRIVER_REQUEST_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_DRIVER_REQUEST_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_DRIVER_REQUEST_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { driverRequestId: action.driverRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_DRIVER_REQUEST_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      driverRequestId: action.driverRequestId
    }

    yield call(api.deleteAttachment, payload)
    yield put({ type: constants.DELETE_DRIVER_REQUEST_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, { driverRequestId: action.driverRequestId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_DRIVER_REQUEST_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_DRIVER_REQUEST_ATTACHMENT.ACTION, deleteAttachment)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobSiteDriverRequests),

    fork(watchCreateJobSiteDriverRequest),
    fork(watchUpdateJobSiteDriverRequest),
    fork(watchDeleteJobSiteDriverRequest),

    fork(watchSagaDriverRequestReport),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobSiteDriverRequestSaga.js